//
// 初期化情報 (オブジェクトのみ)
//

export default {
  allow: {
    begin: '',
    end: ''
  },
  period: {
    begin: '',
    end: '',
    optdays: 0,
    insurancedays: 0,
    insuranceTerm: 0,
    hiseason: false
  },
  charge: {
    basic: 0,
    additional: 0,
    discount: 0
  }
}
